import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 1C5.9375 1 1 5.9375 1 12C1 18.0625 5.9375 23 12 23C18.0625 23 23 18.0625 23 12C23 5.9375 18.0625 1 12 1 Z M 12 3C16.980469 3 21 7.019531 21 12C21 16.980469 16.980469 21 12 21C7.019531 21 3 16.980469 3 12C3 7.019531 7.019531 3 12 3 Z M 17.40625 8.1875L11 14.5625L7.71875 11.28125L6.28125 12.71875L10.28125 16.71875L11 17.40625L11.71875 16.71875L18.8125 9.59375Z" })
});
export default SvgSuccess;
